import _asyncToGenerator from "/home/runner/work/mainrepo/mainrepo/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { Injector } from '@angular/core';
export function sharedInjectorForFrontend(injector) {
  return {
    _sharedInj: true,
    get: token => injector.get(token),
    create: function () {
      var _ref = _asyncToGenerator(function* (token) {
        return Injector.create({
          providers: [{
            provide: token
          }],
          parent: injector
        }).get(token);
      });
      return function create(_x) {
        return _ref.apply(this, arguments);
      };
    }()
  };
}